<template>
  <div class="status-container" :style="{ width: width }">
    <div class="step-container" v-for="(step, index) in steps" :key="index">
      <div class="circle-container">
        <div v-if="step" class="icon-container">
          <div v-if="index > 0" class="bar" :class="[isActive(index) ? 'active': '']"></div>
          <div class="circle" :class="[isActive(index) ? 'active': '']">
            <feather-icon v-if="isActive(index)"  icon="CheckIcon" svgClasses="h-5 w-5"/>
            <div v-else>{{ getIndex(step) }}</div>
            <div class="icon-label" :class="[isActive(index) ? 'active': '']">{{ step }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'StatusStep',
  props: {
    status: {
      type: Number,
      default: -1,
    },
    steps: {
      type: Array,
      required: true,
    },
    width: {
      type: String,
      default: '500px',
    }
  },

  computed:{
    statusNumber() {
      return this.status;
    }
  },

  methods: {
    isActive(index) {
      return index <= this.status;
    },
    getIndex(step) {
      return this.steps.slice(0, this.steps.indexOf(step) + 1).filter(Boolean).length;
    }
  }
}
</script>


<style scoped lang="scss">
.status-container {
  display: flex;

  .step-container {
    display: flex;
    flex-direction: row;
    align-items: center;

    .bar {
      width: 100px;
      height: 2px;
      background-color: #bdbdbd;
    }
    .bar.active {
      background-color: rgba(var(--vs-secondary));
    }


    .circle-container {
      display: flex;
      flex-direction: column;
      text-align: center;

      .icon-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0 0 50px;

        .circle {
          width: 32px;
          height: 32px;
          background-color: #bdbdbd;
          color: white;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;

          .icon-label {
            color: #82868b;
            position: absolute;
            bottom: -30px;
            width: 100px;
          }
          .icon-label.active {
            color: #2c2c2c;
          }
        }
        .circle.active {
          background-color: rgba(var(--vs-secondary));
        }
      }
    }
  }
}
</style>
